module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"articleTitleGenerated":"Article title generated","generate":"Generate","missingImage":"Can not publish an article until there are missing laptop images.","open":"Open","publish":"Publish","published":"Article published","slug":"Slug","specTypes":"Specs","status":"Status","title":"Title","update":"Update post","updated":"Post updated"}}')
  delete Component.options._Ctor
}
